module.exports = __webpack_public_path__ + "img/si.8ca238ab.svg";